export  default {
    getRegions(state) {
        return state.regions;
    },
};